export interface INodesMap {
  [key: string]: OrganizationNode;
}

export interface AppsStateOrganization {
  rootOrganization: OrganizationNode;
  nodes: OrganizationNode[];
  isLoading: boolean;
  isPageActive: boolean;
  nodesMap: INodesMap;
  history: HistoryEvent[];
  settings: OrganizationSettings;
  isLoadingNodesInfo: boolean;
  organizationId: number;
  isCreatingOrganization: boolean;
}

export type OrganizationSettings = {
  searchValue?: string;
  narrowType?: NodeType;
  zoom?: number;
};

export type HistoryEvent = {
  timestamp: string;
  user_id: string;
  action: HistoryActionType;
  resource_id: number;
  old_data: any;
  new_data: any;
  data: AddDeleteNodeData;
};
export enum HistoryActionType {
  created = "created",
  changed = "changed",
  deleted = "deleted",
}

export type AddDeleteNodeData = {
  title: string;
  type: NodeType;
  parentNodeType: NodeType;
  parentTitle: string;
};

export type ChangeNodeData = {
  title: string;
  type: NodeType;
  oldTitle?: string;
  countryCode?: string;
  oldcountryCode?: string;
  city?: string;
  oldcity?: string;
  zipCode?: string;
  oldzipCode?: string;
  addressLine1?: string;
  oldaddressLine1?: string;
  addressLine2?: string;
  oldaddressLine2?: string;
  avatarUrl?: string;
  oldavatarUrl?: string;
  stateProvinceRegion?: string;
  oldstateProvinceRegion?: string;
};

export type createOrganizationDTO = {
  id: number | undefined;
  data: {
    title: string;
    location: Location;
  };
  language: string | undefined;
};

export type Location = {
  countryCode: string;
  city: string;
  zipCode: string;
  addressLine1: string;
  addressLine2?: string;
  timezone: string;
  avatarUrl: string;
  loadFile?: File;
  stateProvinceRegion?: string;
  coordinates: {
    latitude: number;
    longitude: number;
  };
};

export type CountInNode = {
  increase: boolean;
  count?: number;
  nodeId: number;
};

export const EMPTY_LOCATION: Location = {
  countryCode: "",
  city: "",
  zipCode: "",
  addressLine1: "",
  addressLine2: "",
  timezone: "",
  avatarUrl: "",
  coordinates: {
    latitude: 0,
    longitude: 0,
  },
};

export const oldToNewLocations = (oldObj: any): Location => {
  const res: Location = { ...EMPTY_LOCATION };
  if (oldObj.hasOwnProperty("AddressLine1"))
    res.addressLine1 = oldObj.AddressLine1;
  if (oldObj.hasOwnProperty("AddressLine2"))
    res.addressLine2 = oldObj.AddressLine2;
  if (oldObj.hasOwnProperty("City")) res.city = oldObj.City;
  if (oldObj.hasOwnProperty("Coordinates"))
    res.coordinates = {
      latitude: oldObj.Coordinates.Latitude,
      longitude: oldObj.Coordinates.Longitude,
    };
  if (oldObj.hasOwnProperty("CountryCode"))
    res.countryCode = oldObj.CountryCode;
  if (oldObj.hasOwnProperty("Timezone")) res.timezone = oldObj.Timezone;
  if (oldObj.hasOwnProperty("ZipCode")) res.zipCode = oldObj.ZipCode;
  if (oldObj.hasOwnProperty("AvatarUrl")) res.avatarUrl = oldObj.AvatarUrl;
  return res;
};

export enum NodeType {
  Root = "Root",
  Building = "Building",
  Department = "Department",
  Group = "Group",
}

export class OrganizationNode {
  title: string;
  location?: Location;
  leaf?: boolean;
  id: number;
  rootNodeId?: number;
  type: NodeType;
  countOfResidents?: number;
  countOfDevices?: number;
  nodesTree: OrganizationNode[];
  settings?: any[];
}

export type OrganizationNodeSocket = {
  leaf?: boolean;
  location?: Location;
  nodeId: number;
  orgId: number;
  title: string;
  type: NodeType;
};

export type OrganizationNodeImageSocket = {
  nodeId: number;
  orgId: number;
  url: string;
};

export type OrganizationNodeDTO = {
  title: string;
  self: { id: number };
  type?: NodeType;
  nodesTree: OrganizationNodeDTO[];
  countOfResidents?: number;
  countOfDevices?: number;
  location?: Location;
};

export type AddNodeDTO = {
  title: string;
  location?: Location;
  parentNodeId: number;
  type: NodeType;
  leaf?: boolean;
};

export type AddNodeBranchDTO = {
  parentNodeId: number;
  building: {
    title: string;
    location: Location;
  } | null;
  departmentTitle: string;
  groupTitle: string;
};

export enum DeleteStatus {
  FORBID_ME = "Forbid_Me",
  FORBID_CHILDREN = "Forbid_Children",
  ALLOW = "Allow",
  FORBID_PARENT = "Forbid_Parent",
  FORBID_INTEGRATION = "Forbid_integration",
}

export const EMPTY_NODE = (id: number): OrganizationNode => {
  return {
    title: "",
    location: EMPTY_LOCATION,
    id: id,
    type: NodeType.Building,
    nodesTree: [],
  };
};
